import LoadingButton from '@mui/lab/LoadingButton';
import { Button, DialogContent, Grid, TextField } from '@mui/material';
import { useState } from 'react';
import { OnlyFansSextfoceLiveStreamAnnouncementMessage } from '../../../../../hooks/useSextforceLiveStreamAutoAnnouncementsMessages';
import { OnlyFansSubscriber } from '../../../../../hooks/useSubscriber';
import DialogAdaptive from '../../../../common/DialogAdaptive';
import StyledCardTitleBar from '../../../../common/StyledCardTitleBar';
import StyledDialogActions from '../../../../common/StyledDialogActions';

type Props = {
    subscriber: OnlyFansSubscriber;
    groupId: string;
    initialValue?: OnlyFansSextfoceLiveStreamAnnouncementMessage;
    onSubmit: (message: OnlyFansSextfoceLiveStreamAnnouncementMessage) => void;
    isLoading: boolean;
    onCancel: () => void;
    open: boolean;
};

const SextforceLiveStreamAutoAnnouncementsMessageForm = (props: Props) => {
    const { subscriber, groupId, initialValue, onSubmit, isLoading = false, onCancel, open } = props;

    const [message, setMessage] = useState<OnlyFansSextfoceLiveStreamAnnouncementMessage>(
        initialValue || {
            groupId,
            active: true,
            name: '',
            message: '',
        },
    );

    return (
        <DialogAdaptive open={open} onClose={onCancel} maxWidth="sm" fullWidth>
            <StyledCardTitleBar title={initialValue ? 'Update Message' : 'Create Message'} />
            <DialogContent>
                <Grid container spacing={0} alignItems="center" justifyContent="space-between">
                    <Grid item xs={12}>
                        <TextField
                            label="Name"
                            value={message.name}
                            onChange={e => setMessage({ ...message, name: e.target.value })}
                            fullWidth
                            disabled={isLoading}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Message"
                            value={message.message}
                            onChange={e => setMessage({ ...message, message: e.target.value })}
                            rows={4}
                            multiline
                            fullWidth
                            disabled={isLoading}
                        />
                    </Grid>
                </Grid>
            </DialogContent>

            <StyledDialogActions>
                <Button
                    variant="outlined"
                    color="secondary"
                    disabled={isLoading}
                    onClick={() => {
                        if (onCancel) {
                            onCancel();
                        }
                    }}
                >
                    Cancel
                </Button>
                <LoadingButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={!message.name || !message.message}
                    loading={isLoading}
                    onClick={() => {
                        onSubmit(message);
                    }}
                >
                    <span>{initialValue ? 'Update Message' : 'Create Message'}</span>
                </LoadingButton>
            </StyledDialogActions>
        </DialogAdaptive>
    );
};

export default SextforceLiveStreamAutoAnnouncementsMessageForm;
